export const findQueryValueFromString = (urlString) => {
	if (!urlString || !urlString.includes('&')) return;

	const url = urlString.split('&');
	let result = '';

	url.forEach((param) => {
		if (param[0] === 'q' && param[1] === '=') {
			result = param.substring(2, param.length);
		}
	});

	return result;
};

export const getPageNumberFromURL = (url) => {
	if (!url || url === '') {
		console.log('NO URL PROVIDED');
		return '';
	}
	const matches = url.match(/page=([^&]*)/);
	const pageNumber = matches ? matches[1] : '';
	return pageNumber;
};

export const getArticleIdFromURL = (url) => {
	if (!url || url === '') {
		console.log('NO URL PROVIDED');
		return '';
	}
	const id = url.substring(url.lastIndexOf('/') + 1) || '';

	return id;
};

export function getAssetTypeFromURL(url) {
	// Check if the URL is valid
	if (!url || !url.trim()) {
		return 'default';
	}

	// Get the file extension from the URL
	const extension = url.split('.').pop();

	// Check if the extension is for an image file
	if (
		extension === 'png' ||
		extension === 'jpg' ||
		extension === 'jpeg' ||
		extension === 'gif' ||
		extension === 'webp'
	) {
		return 'image';
	}

	// Check if the extension is for a PDF file
	if (extension === 'pdf') {
		return 'pdf';
	}

	// Check if the URL is for a YouTube or Vimeo video
	if (
		url.indexOf('youtube.com') !== -1 ||
		url.indexOf('youtu.be') !== -1 ||
		url.indexOf('vimeo.com') !== -1
	) {
		return 'video-object';
	}

	if (['mov', 'mp4', 'avi', 'webm', 'wmv'].includes(extension)) {
		return 'video';
	}

	// If none of the above conditions are met, return "default"
	return 'default';
}

export function replaceMetaTag(name, newContent) {
	let head = document.getElementsByTagName('head')[0];
	let metaElement = head.querySelector(`meta[name="${name}"]`);

	if (metaElement) {
		metaElement.setAttribute('content', newContent);
	} else {
		let newMetaElement = document.createElement('meta');
		newMetaElement.setAttribute('name', 'description');
		newMetaElement.setAttribute('content', newContent);
		head.appendChild(newMetaElement);
	}
}

export function replaceTitleFromHead(newTitle) {
	let head = document.getElementsByTagName('head')[0];
	let titleElement = head.querySelector('title');

	if (titleElement) {
		titleElement.textContent = newTitle;
	} else {
		let newTitleElement = document.createElement('title');
		newTitleElement.textContent = newTitle;
		head.appendChild(newTitleElement);
	}
}

export function filterExpiredOpportunities(arr) {
	const currentDate = new Date();

	const filteredArray = arr.filter((obj) => {
		if (obj.timeframe_end_on === null) {
			return new Date(obj.timeframe_start_on) > currentDate;
		} else {
			return new Date(obj.timeframe_end_on) > currentDate;
		}
	});

	filteredArray.sort((a, b) => {
		const aDiff = Math.abs(currentDate - new Date(a.timeframe_start_on));
		const bDiff = Math.abs(currentDate - new Date(b.timeframe_start_on));
		return aDiff - bDiff;
	});

	return filteredArray;
}

export const findAsset = (assets, assetEtag) => {
	for (const asset of assets) {
		if (!asset) continue;
		if (asset.etag === assetEtag) {
			return asset;
		}
	}
	return null;
};
